module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="page">\r\n  <a href="#"><i class="iconfont icon-jinrujiantouleft"></i></a>\r\n  <a href="#" class="active">1</a>\r\n  <a href="#">2</a>\r\n  <a href="#">3</a>\r\n  <a href="#">4</a>\r\n  <a href="#"><i class="iconfont icon-jinrujiantouxiao"></i></a>\r\n</div>';

}
return __p
}